import React from "react";
import {
  Briefcase,
  Truck,
  CheckCircle,
  Headset,
  Award,
  ShieldCheck,
  Handshake,
  TrendingUp,
} from "lucide-react";

const AboutPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 bg-white shadow-lg rounded-2xl">
      <h1 className="text-5xl font-bold text-black mb-6 text-center">
        Почему выбирают <span className="text-red-600">МЕТАЛЛ ИВАНЫЧ</span>
      </h1>

      <p className="text-lg text-gray-700 mb-10 text-center max-w-3xl mx-auto">
        <span className="text-red-600">«МЕТАЛЛ ИВАНЫЧ»</span> — надёжный поставщик металлопроката и арматуры для строительства. Мы не просто продаём металл — мы обеспечиваем стабильность, качество и уверенность в каждом проекте. Наша цель — быть не просто поставщиком, а вашим партнёром в строительстве.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Качество и ГОСТ */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
          <div className="flex items-center mb-4">
            <CheckCircle className="text-red-500 w-6 h-6 mr-3" />
            <h2 className="text-2xl font-semibold text-red-600">Сертифицированный металл</h2>
          </div>
          <p className="text-gray-700">
            Мы поставляем только качественную продукцию, соответствующую ГОСТ и ТУ. Все материалы проходят строгий контроль и имеют необходимые сертификаты.
          </p>
        </div>

        {/* Оперативная доставка */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
          <div className="flex items-center mb-4">
            <Truck className="text-red-500 w-6 h-6 mr-3" />
            <h2 className="text-2xl font-semibold text-red-600">Быстрая и точная доставка</h2>
          </div>
          <p className="text-gray-700">
            Собственный автопарк и налаженная логистика позволяют нам доставлять заказы точно в срок — по Москве, области и регионам.
          </p>
        </div>

        {/* Поддержка */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
          <div className="flex items-center mb-4">
            <Headset className="text-red-500 w-6 h-6 mr-3" />
            <h2 className="text-2xl font-semibold text-red-600">Поддержка на каждом этапе</h2>
          </div>
          <p className="text-gray-700">
            От консультации по выбору продукции до сопровождения при отгрузке — мы всегда рядом. Работаем с физлицами и крупными компаниями.
          </p>
        </div>

        {/* Опыт */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
          <div className="flex items-center mb-4">
            <Briefcase className="text-red-500 w-6 h-6 mr-3" />
            <h2 className="text-2xl font-semibold text-red-600">Более 10 лет на рынке</h2>
          </div>
          <p className="text-gray-700">
            За годы работы мы выстроили эффективные процессы и заслужили доверие клиентов по всей России.
          </p>
        </div>

        {/* Гарантии */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
          <div className="flex items-center mb-4">
            <ShieldCheck className="text-red-500 w-6 h-6 mr-3" />
            <h2 className="text-2xl font-semibold text-red-600">Гарантии и надёжность</h2>
          </div>
          <p className="text-gray-700">
            Мы гарантируем соблюдение сроков, объёмов и качества поставки. Контроль на каждом этапе — от склада до объекта.
          </p>
        </div>

        {/* Репутация */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
          <div className="flex items-center mb-4">
            <Award className="text-red-500 w-6 h-6 mr-3" />
            <h2 className="text-2xl font-semibold text-red-600">Доверие клиентов</h2>
          </div>
          <p className="text-gray-700">
            Нас выбирают застройщики, подрядчики, мастера и строительные компании. Репутация — наш главный актив.
          </p>
        </div>

        {/* Партнёрство */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
          <div className="flex items-center mb-4">
            <Handshake className="text-red-500 w-6 h-6 mr-3" />
            <h2 className="text-2xl font-semibold text-red-600">Индивидуальный подход</h2>
          </div>
          <p className="text-gray-700">
            Мы подбираем решения под задачи каждого клиента. Будь то дачный участок или крупная стройка — вы получаете максимум внимания.
          </p>
        </div>

        {/* Рост и надёжность */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
          <div className="flex items-center mb-4">
            <TrendingUp className="text-red-500 w-6 h-6 mr-3" />
            <h2 className="text-2xl font-semibold text-red-600">Развитие и масштаб</h2>
          </div>
          <p className="text-gray-700">
            Мы расширяем складские запасы, улучшаем сервис и внедряем новые технологии, чтобы быть ещё ближе к клиенту.
          </p>
        </div>
      </div>

      <div className="mt-12 text-center">
        <p className="text-xl font-medium text-gray-800">
          Надёжный металлопрокат — основа вашего строительства. С <span className="text-red-600">МЕТАЛЛ ИВАНЫЧ</span> вы выбираете стабильность, скорость и партнёрский подход.
        </p>
      </div>
    </div>
  );
};

export default AboutPage;
